import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import history from 'routing/history';
import EditClaimIcon from 'products/nomad_insurance/assets/img/claims/edit.svg';
import DeleteClaimIcon from 'products/nomad_insurance/assets/img/claims/delete.svg';
import { setClaimId } from 'products/nomad_insurance/views/ClaimsForm/state';
import { deleteClaim } from 'products/nomad_insurance/views/Profile/ClaimsDashboard/state';
import { StyledButton } from '../../styled';
import useClaimProgression from '../../../../hooks/useClaimProgression';
import DeleteClaimConfirmation from '../DeleteClaimConfirmation';

const DraftButtons = ({ claim }) => {
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const { isDraft } = useClaimProgression(claim);
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.nomadInsurance.claims);

  const editDraftClaim = () => {
    dispatch(setClaimId(claim.id));
    history.push('/nomad-insurance/claim');
  };

  const deleteDraftClaim = () => {
    dispatch(deleteClaim({ claimID: claim.id }));
  };

  const closeDeleteConfirmation = () => {
    setDeleteConfirmationOpen(false);
  };

  const onDeleteBtnClick = () => {
    setDeleteConfirmationOpen(true);
  };

  if (!isDraft) return null;
  return (
    <>
      <DeleteClaimConfirmation
        isOpen={!!deleteConfirmationOpen}
        onClose={closeDeleteConfirmation}
        onConfirmation={deleteDraftClaim}
      />
      <StyledButton
        color="fountainBlue"
        thickness="thin"
        onClick={editDraftClaim}
        disabled={isLoading}
      >
        <img src={EditClaimIcon} alt="Edit claim" />
        Edit
      </StyledButton>
      <StyledButton color="fuzzyWuzzyBrown" thickness="thin" onClick={onDeleteBtnClick}>
        <img src={DeleteClaimIcon} alt="Delete claim" />
        Delete
      </StyledButton>
    </>
  );
};

DraftButtons.propTypes = {
  claim: PropTypes.any.isRequired
};

export default DraftButtons;
